/**
 * Created by jv on 26/01/2017.
 */
const utils = require("Sources/utils/utils");
const Article = require("Sources/models/store/article");

module.exports = class Catalog
{
  constructor(options)
  {
    options = utils.isNotNull(options) ? options : {};

    this.key = options.key;
    this.currency = options.valuta;
    this.type = options.type;
    this.locale = options.locale;

    this.extraInfoKey = options["extra-info-key"];

    this.articles = options["catalog-articles"];
  }

  set articles(articles)
  {
    this._articles = [];

    if(utils.isArray(articles))
    {
      for(var i = 0; i < articles.length; i++)
      {
        this._articles.push(new Article(articles[i]));
      }
    }
  }

  get articles()
  {
    return this._articles;
  }

  getArticleForKey(key)
  {
    for(var i = 0; i < this.articles.length; i++)
    {
      if(this.articles[i].key === key)
      {
        return this.articles[i];
      }
    }

    return null;
  }

  get country()
  {
    return utils.getValueFromSplit(this.locale, 1, "_");
  }

  get language()
  {
    return utils.getValueFromSplit(this.locale, 0, "_");
  }
};



// WEBPACK FOOTER //
// ./app/js/models/store/catalog.js